import axios from 'axios';
import { toggleEnvironment } from './apiClient';

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : '',
  };
};

export const api = {
  get: async (endpoint) => {
    const response = await axios.get(endpoint, {
      baseURL: toggleEnvironment(),
      headers: getAuthHeaders()
    });
    return response;
  },
  post: async (endpoint, data) => {
    const response = await axios.post(endpoint, data, {
      baseURL: toggleEnvironment(),
      headers: getAuthHeaders()
    });
    return response;
  },
  put: async (endpoint, data) => {
    const response = await axios.put(endpoint, data, {
      baseURL: toggleEnvironment(),
      headers: getAuthHeaders()
    });
    return response;
  },
  delete: async (endpoint) => {
    const response = await axios.delete(endpoint, {
      baseURL: toggleEnvironment(),
      headers: getAuthHeaders()
    });
    return response;
  }
}; 